import { InjectionToken } from '@angular/core';
import type { PmWorkspaceComponent } from '../../../layout/pm-workspace/pm-workspace.component';

/**
 * What Settings > Services still reads from the workspace: the open setting and unsaved-assign guard used by the settings sidebar and URL handling, the shared catalog / custom services lists the Add client form also uses, the team and client lists, and the shared dropdown helpers.
 * The workspace provides itself under this token. Shrinks as the shared stores are split out.
 */
export type PmSettingsServicesHost = Pick<
  PmWorkspaceComponent,
  | 'acsAssignClientDropdownId'
  | 'acsEmailWorkflowTemplateTypeHighlighted'
  | 'acsReminderClientHighlighted'
  | 'acsReminderStaffHighlighted'
  | 'acsServiceFrequencyHighlighted'
  | 'acsServiceManagerDropdownId'
  | 'activeDropdown'
  | 'activeServiceTab'
  | 'activeSettingItem'
  | 'addServiceAssignClientHighlighted'
  | 'addServiceAssignClientMultiselectSearch'
  | 'addServiceManagerHighlighted'
  | 'addServiceManagerLoading'
  | 'addServiceManagerSearch'
  | 'addServiceReminderMultiselectSearch'
  | 'applyDefaultServicesResponse'
  | 'assignClientsData'
  | 'assignExportMenuOpen'
  | 'assignMatrixPageNumber'
  | 'assignMatrixPageSize'
  | 'assignMatrixSearchReloadTimer'
  | 'assignMatrixTotalCount'
  | 'assignSearchQuery'
  | 'assignmentColumnIds'
  | 'assignmentsError'
  | 'assignmentsLoading'
  | 'availableClientTypes'
  | 'bookMeetingClientsLoading'
  | 'captureAssignBaselineFromCurrent'
  | 'catalogServiceKey'
  | 'catalogServices'
  | 'clientTypeLabelForCode'
  | 'clientTypeLabelFromRow'
  | 'clientTypesForCustomServiceRow'
  | 'clientsBookMeetingPickerRows'
  | 'clientsDirectoryLoading'
  | 'clientsDirectoryRows'
  | 'clientsSortedRows'
  | 'closeServicesFilterDropdowns'
  | 'customAddedServices'
  | 'customServiceStatusKey'
  | 'dedupeRemindersTimingsFromApi'
  | 'defaultServicesCatalogRows'
  | 'effectiveActingUserId'
  | 'effectiveDirectoryParentUserId'
  | 'effectiveDirectoryUserIdForClientsList'
  | 'effectivePracticeParentUserId'
  | 'ensureDirectoryClientsLoadedForServiceReminders'
  | 'ensurePmContextLoaded'
  | 'ensureTeamLoadedForServiceManager'
  | 'filteredClientRows'
  | 'getAssignSourceRows'
  | 'getAssignmentColumnServices'
  | 'getEntityTagClass'
  | 'getEntityTagsForCatalogService'
  | 'getEntityTagsForDefaultService'
  | 'getFrequencyTagClass'
  | 'getTotalServicesCount'
  | 'hasUnsavedChanges'
  | 'loadAssignmentsMatrixForTab'
  | 'loadClientsForBookMeetingPicker'
  | 'loadCustomServicesForSettings'
  | 'loadServicePackagesForTab'
  | 'loadTeamForAddServiceModalOnly'
  | 'mergedDirectoryClientRowsForScheduleLabels'
  | 'navigateDdList'
  | 'newService'
  | 'originalClientData'
  | 'packageGridRows'
  | 'parseCatalogTemplateEntries'
  | 'pendingAssignLeaveServiceTab'
  | 'pendingAssignLeaveSettingLabel'
  | 'primaryBrandColor'
  | 'readClientCustomServiceRowNumericId'
  | 'readClientCustomServiceRowUserId'
  | 'reminderCascadeTimingHighlighted'
  | 'reminderCascadeUnitHighlighted'
  | 'reminders'
  | 'serviceStatusMap'
  | 'servicesFilterDdRect'
  | 'servicesFilterDropdownOpen'
  | 'servicesFilterPopoverOpen'
  | 'servicesSettingsLoading'
  | 'setSettingActive'
  | 'settingsClientUniversalId'
  | 'showAssignClientsLeaveConfirmModal'
  | 'stopProp'
  | 'stopPropAllowSpaceInFields'
  | 'teamMemberDisplayNameForUserId'
  | 'teamMembersApi'
  | 'templateLibraryClientTypes'
  | 'toggleDropdown'
>;

export const PM_SETTINGS_SERVICES_HOST = new InjectionToken<PmSettingsServicesHost>('PmSettingsServicesHost');
